/**
 * Slug точки — это DNS-метка поддомена: латиница в нижнем регистре, цифры и дефис,
 * без дефиса в начале и в конце, до 30 символов.
 */
export const SLUG_MAX_LENGTH = 30;

export const SLUG_PATTERN = /^[a-z0-9](?:[a-z0-9-]{0,28}[a-z0-9])?$/;

export const RESERVED_SLUGS: readonly string[] = [
  'www',
  'api',
  'app',
  'admin',
  'mail',
  'static',
  'assets',
  'demo',
  'owner',
  'help',
];

export function isValidSlug(value: string): boolean {
  return SLUG_PATTERN.test(value) && !RESERVED_SLUGS.includes(value);
}

export function slugProblem(value: string): string | null {
  if (value.length === 0) return 'slug пустой';
  if (value.length > SLUG_MAX_LENGTH) return `slug длиннее ${SLUG_MAX_LENGTH} символов`;
  if (!SLUG_PATTERN.test(value)) {
    return 'slug: только латиница в нижнем регистре, цифры и дефис, без дефиса по краям';
  }
  if (RESERVED_SLUGS.includes(value)) return `slug «${value}» зарезервирован`;
  return null;
}
